document.querySelectorAll('[data-social-picker]').forEach((picker) => {
  const button = picker.querySelector('[data-social-picker-button]');
  const menu = picker.querySelector('.social-picker-menu');

  if (!button || !menu) return;

  button.addEventListener('click', (event) => {
    event.stopPropagation();
    const isOpen = !menu.hasAttribute('hidden');
    document.querySelectorAll('.social-picker-menu').forEach((openMenu) => {
      openMenu.setAttribute('hidden', '');
    });
    document.querySelectorAll('[data-social-picker-button]').forEach((openButton) => {
      openButton.setAttribute('aria-expanded', 'false');
    });

    if (!isOpen) {
      menu.removeAttribute('hidden');
      button.setAttribute('aria-expanded', 'true');
    }
  });
});

document.addEventListener('click', () => {
  document.querySelectorAll('.social-picker-menu').forEach((menu) => {
    menu.setAttribute('hidden', '');
  });
  document.querySelectorAll('[data-social-picker-button]').forEach((button) => {
    button.setAttribute('aria-expanded', 'false');
  });
});

document.querySelectorAll('[data-vehicle-card]').forEach((card) => {
  const openButton = card.querySelector('[data-vehicle-open]');
  const modal = card.querySelector('[data-vehicle-modal]');
  const closeButtons = card.querySelectorAll('[data-vehicle-close]');

  if (!openButton || !modal) return;

  const closeModal = () => {
    modal.setAttribute('hidden', '');
    document.body.classList.remove('modal-open');
    openButton.focus();
  };

  openButton.addEventListener('click', () => {
    modal.removeAttribute('hidden');
    document.body.classList.add('modal-open');
    const closeButton = modal.querySelector('.vehicle-modal-close');
    if (closeButton) closeButton.focus();
  });

  closeButtons.forEach((closeButton) => {
    closeButton.addEventListener('click', closeModal);
  });

  modal.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeModal();
  });
});

document.querySelectorAll('[data-photo-carousel]').forEach((carousel) => {
  const track = carousel.querySelector('[data-carousel-track]');
  const next = carousel.querySelector('[data-carousel-next]');
  const prev = carousel.querySelector('[data-carousel-prev]');

  if (!track) return;

  const scrollByAmount = () => Math.max(track.clientWidth * 0.86, 280);

  if (next) {
    next.addEventListener('click', () => {
      track.scrollBy({ left: scrollByAmount(), behavior: 'smooth' });
    });
  }

  if (prev) {
    prev.addEventListener('click', () => {
      track.scrollBy({ left: -scrollByAmount(), behavior: 'smooth' });
    });
  }
});

document.querySelectorAll('[data-vehicle-search]').forEach((form) => {
  const query = form.querySelector('[data-vehicle-query]');
  const year = form.querySelector('[data-vehicle-year]');
  const make = form.querySelector('[data-vehicle-make]');
  const model = form.querySelector('[data-vehicle-model]');

  if (!query) return;

  form.addEventListener('submit', () => {
    const parts = [year?.value, make?.value, model?.value]
      .map((part) => (part || '').trim())
      .filter(Boolean);

    query.value = parts.join(' ');
  });
});
